import * as E from 'fp-ts/Either';
import * as t from 'io-ts';
import { NumberFromString } from 'io-ts-types';

// Custom codec
export const AnyStringOrNumber = (defaultValue = 0) =>
  new t.Type<number, number, unknown>(
    'EmptyStringToZero',
    t.number.is,
    (u, c) => {
      const numberValidation = t.number.validate(u, c);
      if (E.isRight(numberValidation)) {
        return t.success(numberValidation.right);
      }

      const numberStringValidation = NumberFromString.validate(u, c);
      if (E.isRight(numberStringValidation)) {
        return t.success(numberStringValidation.right);
      }

      if (typeof u === 'string') {
        return t.success(defaultValue);
      }

      return t.failure(u, c);
    },
    Number,
  );
